import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import Footer from "./Footer";
const Layout = ({  title, description, keywords, author,children }) => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <title>{title}</title>
        
      </Helmet>
      <Navbar />
    
      {children}
      <Footer />

    </div>
  );
};

Layout.defaultProps = {
  title: "Mba Solutions - Home",
  description: "ISO Certifications ",
  keywords: "mern,react,node,mongodb,mbasolutions",
  author: "MBA",
};

export default Layout;